/* =========================================================
   NA LEIBERL – "Gesetzliche Gewährleistung" auf der Produktseite
   Link unter den Aufklappern (Beschreibung, Material & Pflege …),
   öffnet ein Popup mit der EU-Mitteilung zur Gewährleistung.
   Dateien kommen aus snippets/meta-tags.liquid: window.NL_GEWAEHR = { bild, pdf }
   ========================================================= */
(function () {
  'use strict';

  var TEXTE = {
    link: 'Gesetzliche Gewährleistung',
    titel: 'Gesetzliche Gewährleistung',
    gross: 'In voller Größe öffnen',
    eu: 'Mitteilung als Text lesen (europa.eu)',
    euUrl: 'https://europa.eu/youreurope/garantien',
    schliessen: 'Schließen'
  };

  var CSS =
    '.nl-gw-link{display:inline-block;margin:2rem 0 0;padding:0;border:0;background:none;cursor:pointer;' +
      'font-family:"Nunito",var(--font-body-family),sans-serif;font-weight:600;font-size:1.4rem;' +
      'color:var(--nl-schwarz,#211D1E);text-decoration:underline;text-underline-offset:.3rem;text-decoration-thickness:1px}' +
    '.nl-gw-link:hover{color:var(--nl-rot,#D12D36)}' +
    '.nl-gw{width:min(68rem,calc(100vw - 2.4rem));max-height:calc(100vh - 4rem);padding:0;border:0;border-radius:16px;' +
      'background:#fff;color:var(--nl-schwarz,#211D1E);box-shadow:0 20px 60px rgba(0,0,0,.25);overflow:hidden}' +
    '.nl-gw::backdrop{background:rgba(33,29,30,.55)}' +
    '.nl-gw__inner{display:flex;flex-direction:column;max-height:calc(100vh - 4rem)}' +
    '.nl-gw__kopf{display:flex;justify-content:flex-end;padding:1.2rem 1.2rem 0}' +
    '.nl-gw__zu{width:4rem;height:4rem;display:flex;align-items:center;justify-content:center;border:0;border-radius:50%;' +
      'background:transparent;color:inherit;cursor:pointer}' +
    '.nl-gw__zu:hover{background:#F4F4F4}' +
    '.nl-gw__zu svg{width:2rem;height:2rem;fill:none;stroke:currentColor;stroke-width:2.2;stroke-linecap:round}' +
    '.nl-gw__body{overflow:auto;padding:0 2.4rem}' +
    '.nl-gw__body img{display:block;width:100%;height:auto}' +
    '.nl-gw__body iframe{display:block;width:100%;height:70vh;border:0}' +
    '.nl-gw__fuss{display:flex;flex-wrap:wrap;justify-content:space-between;gap:1rem 2rem;padding:1.6rem 2.4rem 2rem;' +
      'font-family:"Nunito",var(--font-body-family),sans-serif;font-weight:600;font-size:1.4rem}' +
    '.nl-gw__fuss a{color:inherit;text-decoration:underline;text-underline-offset:.3rem}' +
    '.nl-gw__fuss a:hover{color:var(--nl-rot,#D12D36)}' +
    '@media screen and (max-width:749px){.nl-gw__body{padding:0 1.4rem}.nl-gw__fuss{padding:1.4rem 1.4rem 1.8rem}}';

  var X = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var dialog = null;

  function popupBauen(cfg) {
    if (dialog) return dialog;
    var inhalt = cfg.bild
      ? '<img src="' + cfg.bild + '" alt="Gesetzliche Gewährleistung: Mitteilung der Europäischen Union zu Ihren Rechten" loading="lazy">'
      : '<iframe src="' + cfg.pdf + '#view=FitH" title="' + TEXTE.titel + '" loading="lazy"></iframe>';
    var gross = cfg.pdf || cfg.bild;
    dialog = document.createElement('dialog');
    dialog.className = 'nl-gw';
    dialog.setAttribute('aria-label', TEXTE.titel);
    dialog.innerHTML =
      '<div class="nl-gw__inner">' +
        '<div class="nl-gw__kopf"><button type="button" class="nl-gw__zu" aria-label="' + TEXTE.schliessen + '">' + X + '</button></div>' +
        '<div class="nl-gw__body">' + inhalt + '</div>' +
        '<div class="nl-gw__fuss">' +
          '<a href="' + gross + '" target="_blank" rel="noopener">' + TEXTE.gross + '</a>' +
          '<a href="' + TEXTE.euUrl + '" target="_blank" rel="noopener">' + TEXTE.eu + '</a>' +
        '</div>' +
      '</div>';
    document.body.appendChild(dialog);
    dialog.querySelector('.nl-gw__zu').addEventListener('click', function () { dialog.close(); });
    // Klick auf den abgedunkelten Hintergrund schließt
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    dialog.addEventListener('close', function () { document.documentElement.style.overflow = ''; });
    return dialog;
  }

  function linkEinbauen() {
    var cfg = window.NL_GEWAEHR || {};
    if (!cfg.bild && !cfg.pdf) return true;
    var info = document.querySelector('.product__info-container');
    if (!info) return false;
    if (info.querySelector('.nl-gw-link')) return true;
    var acc = info.querySelector('.nl-acc');
    if (!acc) return false;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'nl-gw-link';
    btn.setAttribute('aria-haspopup', 'dialog');
    btn.textContent = TEXTE.link;
    btn.addEventListener('click', function () {
      var d = popupBauen(cfg);
      if (typeof d.showModal === 'function') {
        d.showModal();
        document.documentElement.style.overflow = 'hidden';
      } else {
        window.open(cfg.pdf || cfg.bild, '_blank', 'noopener');
      }
    });
    acc.insertAdjacentElement('afterend', btn);
    return true;
  }

  function start() {
    var st = document.createElement('style');
    st.textContent = CSS;
    document.head.appendChild(st);
    if (linkEinbauen()) return;
    // Die Aufklapper werden per Script gebaut – warten, bis sie da sind
    var mo = new MutationObserver(function () { if (linkEinbauen()) mo.disconnect(); });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 15000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
